import { Injectable, inject } from '@angular/core';
// import { SsApiService } from '../api/ss-api.service';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, tap, filter, first, switchMap } from 'rxjs/operators';
import { CommonDataService } from '../common-data.service';
import { LimitStatus, LimitType, resolvePeriodMessage, StatusMessageList } from './data/user-limits.data';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class UserLimitsService {
  private _data = inject(CommonDataService);
  private _user = inject(UserService);


  /**
   * Limits observable data
   */
  public readonly limits$: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor() {
    this.userLimits().subscribe();
  }

  /**
   * Returns user limits from Backend and prepare for using in frontend
   */
  userLimits(): Observable<any> {
    // return this._user.auth$.pipe(
    //   filter(Boolean),
    //   first(),
    //   switchMap(() => this._api.userLimits()),
    //   map(response => (response || []).map(limit => ({
    //     ...limit,
    //     status_message: (limit.status === LimitStatus.CONFIRMED_DISABLE && !limit.disable_at) ?
    //       StatusMessageList[LimitStatus.CONFIRMED_DISABLED_NO_DATE] :
    //       StatusMessageList[limit.status],
    //     period_message: resolvePeriodMessage(limit.period),
    //     accounts: (limit.accounts || [])
    //       .filter(acc => this._data.currencyList.map(curr => curr.code).includes(acc.currency))
    //       .map(account => ({
    //         ...account,
    //         active_until: new Date(account.active_until),
    //         amount: this._data.subunitsToUnits(account.amount_cents, account.currency),
    //         current_amount: this._data.subunitsToUnits(account.current_value_amount_cents, account.currency),
    //         currency_symbol: this._data.currencySymbol(account.currency)
    //       })),
    //     created_at: new Date(limit.created_at),
    //     disable_at: limit.disable_at ? new Date(limit.disable_at) : null,
    //     confirm_until: limit.confirm_until ? new Date(limit.confirm_until) : null,
    //   }))),
    //   map(response => ({
    //     [LimitType.DEPOSIT]: response.filter(limit => limit.type === LimitType.DEPOSIT),
    //     [LimitType.LOSS]: response.filter(limit => limit.type === LimitType.LOSS),
    //     [LimitType.WAGER]: response.filter(limit => limit.type === LimitType.WAGER),
    //     [LimitType.COOLINGOFF]: response.filter(limit => limit.type === LimitType.COOLINGOFF),
    //     [LimitType.SELFEXCLUSION]: response.filter(limit => limit.type === LimitType.SELFEXCLUSION),
    //     [LimitType.SESSION]: response.filter(limit => limit.type === LimitType.SESSION),
    //     [LimitType.REALITYCHECK]: response.filter(limit => limit.type === LimitType.REALITYCHECK),
    //   })),
    //   tap(limits => this.limits$.next(limits))
    // );
    return of({});
  }

  /**
   * Create new limit or update existing
   *
   * @param limit
   */
  createUpdateLimit(limit): Observable<any> {
    // return this._api.postUserLimits({
    //   user_limit: limit
    // });
    return of({});
  }

  /**
   * Delete limit by id
   *
   * @param id
   */
  deleteLimit(id: string): Observable<any> {
    // return this._api.deleteUserLimit(id);
    return of({});
  }

  /**
   * Confirm user limit
   *
   * @param token
   */
  confirmLimit(token: string): Observable<any> {
    // return this._api.userLimitsConfirm({
    //   token
    // });
    return of({});
  }

}
